export default "__VITE_ASSET__AZOI3J3a__"